import { DataTable } from "@/components/ui/data-table";
import type { MailOutboxItem } from "@/lib/notification.api";
import { MAIL_OUTBOX_EMPTY_MESSAGE } from "../mailOutboxPage.constants";
import { createMailOutboxColumns } from "../mailOutboxColumns";

interface MailOutboxTableProps {
  rows: MailOutboxItem[];
  isLoading: boolean;
  retryingId: number | null;
  onOpenDetail: (item: MailOutboxItem) => void;
  onRetry: (id: number) => void;
}

export function MailOutboxTable({
  rows,
  isLoading,
  retryingId,
  onOpenDetail,
  onRetry,
}: MailOutboxTableProps) {
  return (
    <DataTable
      columns={createMailOutboxColumns({ retryingId, onOpenDetail, onRetry })}
      data={rows}
      loading={isLoading}
      emptyMessage={MAIL_OUTBOX_EMPTY_MESSAGE}
    />
  );
}
